import { PHASES } from '../constants';
import {
  startRound, placeBid, pass, bidRange, highestBid, lowestInMarket, activeBidders,
} from './auctionActions';
import { pick, resolveSale, everyoneHasPicked } from './saleActions';

// The engine's one entry point, same shape as the sibling games:
// dispatch(state, action) -> newState. Pure, plain-JSON in and out.

export const ACTIONS = {
  /** Phase 1: the turn player raises the bid. */
  BID: 'BID',
  /** Phase 1: the turn player passes, takes the cheapest house, pays half. */
  PASS: 'PASS',
  /** Phase 2: one player's secret pick of a house to sell. */
  PICK: 'PICK',
  /** Phase 2: everybody has picked; reveal and pay out. */
  RESOLVE_SALE: 'RESOLVE_SALE',
  /** Deal the next round after a round summary has been read. */
  START_ROUND: 'START_ROUND',
};

export const dispatch = (state, action) => {
  switch (action.type) {
    case ACTIONS.BID:
      if (state.meta.roundOver) return state;
      return placeBid(state, action);

    case ACTIONS.PASS:
      if (state.meta.roundOver) return state;
      return pass(state, action);

    case ACTIONS.PICK:
      if (state.meta.roundOver) return state;
      return pick(state, action);

    case ACTIONS.RESOLVE_SALE:
      if (!everyoneHasPicked(state)) return state;
      return resolveSale(state);

    case ACTIONS.START_ROUND:
      // Only ever legal between rounds, which is also what stops a double
      // click (or two clients racing) from dealing two rounds.
      if (!state.meta.roundOver || state.meta.phase === PHASES.FINISHED) return state;
      return startRound(state);

    default:
      return state;
  }
};

export {
  startRound, placeBid, pass, bidRange, highestBid, lowestInMarket, activeBidders,
  pick, resolveSale, everyoneHasPicked,
};
